import type { VerificationMethod } from '@/types';

interface Props {
  message: string;
  /** Lets the verifier quote the attempt to the institution; null when nothing was logged. */
  verificationId?: string | null;
  /** What was being checked; a result code is a Statement of Result. */
  method?: VerificationMethod;
  onRetry: () => void;
}

export default function ResultFailed({ message, verificationId, method, onRetry }: Props) {
  return (
    <div className="space-y-5">
      <div className="flex flex-col items-center gap-3 text-center">
        <div className="flex h-16 w-16 items-center justify-center rounded-full bg-red-50 text-red-600 ring-8 ring-red-50/60">
          <i className="ri-close-line text-3xl" />
        </div>
        <div>
          <h2 className="text-xl font-semibold text-red-700">
            {method === 'result' ? 'STATEMENT OF RESULT' : 'CERTIFICATE'} NOT VERIFIED
          </h2>
          <p className="mt-1 text-sm text-navy-500">{message}</p>
        </div>
      </div>

      {verificationId && (
        <div className="flex flex-col gap-0.5 rounded-md border border-navy-100 bg-navy-50/60 px-4 py-3 sm:flex-row sm:items-center sm:justify-between sm:gap-4">
          <span className="text-xs font-medium uppercase tracking-wide text-navy-400">
            Verification ID
          </span>
          <span className="break-all font-mono text-sm font-medium text-navy-900">
            {verificationId}
          </span>
        </div>
      )}

      <div className="rounded-md border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-800">
        Please check the details you entered and try again. If the problem persists, contact the
        issuing institution.
      </div>

      <button
        onClick={onRetry}
        className="flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md border border-navy-200 bg-white px-4 py-2.5 text-sm font-medium text-navy-800 transition hover:bg-navy-50 cursor-pointer"
      >
        <i className="ri-refresh-line" />
        Try Again
      </button>
    </div>
  );
}